import { useEffect, useRef } from 'react';
import styles from './Cursor.module.css';

export default function Cursor() {
  const cursorRef = useRef(null);
  const ringRef = useRef(null);
  const mx = useRef(0), my = useRef(0);
  const rx = useRef(0), ry = useRef(0);
  const rafRef = useRef(null);

  useEffect(() => {
    const onMove = (e) => {
      mx.current = e.clientX;
      my.current = e.clientY;
      if (cursorRef.current) {
        cursorRef.current.style.left = e.clientX - 6 + 'px';
        cursorRef.current.style.top = e.clientY - 6 + 'px';
      }
    };

    const animate = () => {
      rx.current += (mx.current - rx.current - 18) * 0.12;
      ry.current += (my.current - ry.current - 18) * 0.12;
      if (ringRef.current) {
        ringRef.current.style.left = rx.current + 'px';
        ringRef.current.style.top = ry.current + 'px';
      }
      rafRef.current = requestAnimationFrame(animate);
    };

    const onEnter = () => {
      if (cursorRef.current) cursorRef.current.style.transform = 'scale(2)';
      if (ringRef.current) ringRef.current.style.transform = 'scale(1.5)';
    };
    const onLeave = () => {
      if (cursorRef.current) cursorRef.current.style.transform = 'scale(1)';
      if (ringRef.current) ringRef.current.style.transform = 'scale(1)';
    };

    document.addEventListener('mousemove', onMove);
    document.querySelectorAll('button, a').forEach(el => {
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mouseleave', onLeave);
    });

    rafRef.current = requestAnimationFrame(animate);
    return () => {
      document.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <>
      <div ref={cursorRef} className={styles.cursor} />
      <div ref={ringRef} className={styles.ring} />
    </>
  );
}
